import "./PollyPreview.scss";

import { NominalQuestion, TeamsApplicationTypes, TeamsSurveyDraft, TeamsUser } from "@teams/types";
import moment from "moment";

import { useUserInfo } from "../../../../_shared/actions/useUserInfo";
import { DefaultPreview, PollPreview, QuizPreview, SurveyPreview } from "./components";

type Props = {
  survey: TeamsSurveyDraft;
};

export const PollyPreview: React.FC<Props> = props => {
  // making a copy of survey and using it in previews.
  // there are some methods in the card generation code which modifies the
  // form fields which in turn modifying the polly authoring form.
  // this copy make sure original form fields aren't changed.
  const survey = {
    ...props.survey,
    // making a copy of questions
    questions: props.survey.questions.map(q => ({
      ...q,
      // make a copy of choices.
      ...("choices" in q && {
        choices: (q as NominalQuestion).choices.map(c => ({ ...c })),
      }),
    })),
  };

  const userInfo = useUserInfo();

  const haveNoQuestions =
    survey.questions.length === 1 && !survey.questions[survey.questions.length - 1].label;

  if (haveNoQuestions) {
    return (
      <div style={{ opacity: 0.3 }}>
        <DefaultPreview />
      </div>
    );
  }

  const draft = {
    ...survey,
    // string to date conversion
    ...(survey.deliverAt && {
      deliverAt: moment(survey.deliverAt).toDate(),
    }),
    // placeholders
    title: survey.title || "Enter the title of your polly",
    questions: (survey.questions || []).map(q => ({
      ...q,
      label: q.label || "Enter your question",
    })),
    // adding fake id because it's needed for the management menu,
    id: "sur:fake_id",
    // convert openDuration to closeAt
    closeAt:
      !survey.closeAt && survey.openDuration && survey.deliverAt
        ? moment(survey.deliverAt).add(moment.duration(survey.openDuration)).toDate()
        : survey.closeAt
        ? moment(survey.closeAt).toDate()
        : undefined,
  };

  const owner: TeamsUser = {
    name: userInfo.user.name,
    upn: userInfo.user.upn,
    aadObjectId: userInfo.user.userId,
    teamsUserId: "",
    id: "usr:fake",
  };

  const tenantId = userInfo.user.tenantId;

  const applicationType: TeamsApplicationTypes = "msteams";

  return (
    <>
      {survey.type === "quiz" && (
        <QuizPreview
          draft={draft}
          owner={owner}
          applicationType={applicationType}
          tenantId={tenantId}
        />
      )}

      {survey.type === "poll" && (
        <PollPreview
          draft={draft}
          owner={owner}
          applicationType={applicationType}
          tenantId={tenantId}
        />
      )}

      {survey.type === "survey" && (
        <SurveyPreview
          draft={draft}
          owner={owner}
          applicationType={applicationType}
          tenantId={tenantId}
        />
      )}
    </>
  );
};
